import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import About from '../views/About.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // component: About
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/honor',
    name: 'Honor',
    // component: About
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Honor.vue')
  },
  {
    path: '/face-recognition',
    name: 'FaceRecognition',
    component: () => import('../views/FaceRecognition.vue')
  },
  {
    path: '/face-landmark',
    name: 'FaceLandmark',
    component: () => import('../views/FaceLandmark.vue')
  },
  {
    path: '/lpr',
    name: 'LPR',
    component: () => import('../views/LPR.vue')
  },
  {
    path: '/vehicle-recognition',
    name: 'VehicleRecognition',
    component: () => import('../views/VehicleRecognition.vue')
  },
  {
    path: '/live-detection',
    name: 'LiveDetection',
    component: () => import('../views/LiveDetection.vue')
  },
  {
    path: '/ocr',
    name: 'OCR',
    component: () => import('../views/OCR.vue')
  },
  {
    path: '/segmentation',
    name: 'Segmentation',
    component: () => import('../views/Segmentation.vue')
  },
  {
    path: '/gesture',
    name: 'Gesture',
    component: () => import('../views/Gesture.vue')
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0}
  }
})

export default router
